import React, { useContext, useEffect, useState } from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import UserPanel from '../user-panel/UserPanel';
import './Header.scss';
import { Template } from 'devextreme-react/core/template';
import type { HeaderProps } from '../../types';
import { SelectBox } from 'devextreme-react';
import TenantContext from '../../contexts/tenantContext';
import { TenantDTO, TenantsApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { useScreenSize } from '../../utils/media-query';

export default function Header({ menuToggleEnabled, title, toggleMenu }: HeaderProps) {
  const { currentTenant, setCurrentTenantById, tenants } = useContext(TenantContext);
   const { isXSmall, isSmall } = useScreenSize();


  
  return (
    <header className={'header-component'}>
      <Toolbar className={'header-toolbar'}>
        <Item
          visible={menuToggleEnabled}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item
          location={'before'}
          cssClass={'header-title'}
          text={title}
          visible={!!title}
        />
        <Item
          location={'center'}
          widget='dxSelectBox'
          locateInMenu={'auto'}
        >
           {tenants != null &&
          <SelectBox
            items={tenants}
            width={isXSmall ? 170 : (isSmall ? 220 : 300)}
            displayExpr={'Name'}
            valueExpr={'Id'} 
            value={currentTenant.Id}  
            onValueChanged={(e) => {e.value && setCurrentTenantById(e.value)}}   
            labelMode='floating'
          />
           }
        </Item>
        <Item
          location={'after'}
          locateInMenu={'auto'}
          menuItemTemplate={'userPanelTemplate'}
        >
          <Button
            className={'user-button authorization'}
            width={210}
            height={'100%'}
            stylingMode={'text'}
          >
            <UserPanel menuMode={'context'} />
          </Button>
        </Item>
        <Template name={'userPanelTemplate'}>
          <UserPanel menuMode={'list'} />
        </Template>
      </Toolbar>
    </header>
  )
}
